module.exports = __webpack_public_path__ + "assets/media/phone-about-l.4dba770a.jpg";